export default "__VITE_ASSET__e872624c__"